/**
 * Raw GraphQL API response structure for epoch data
 */
export interface EpochApiData {
  epochNumber: number
  startTimestamp: string
  dists: string
  weekly: string
  mints: string
  gaugesMint: string
  mintBlockNumber: number
  recycled: string
  pool2Mint: string
  teamMint: string
  recycledPercentage: number
  freshPercentage: number
  circulatingEmission: string
  circulatingSupply: string
}

/**
 * Store DAO for initializing EpochStore
 * Normalized data structure for epoch entity store
 */
export interface EpochStoreDAO {
  epochNumber: number
  startTimestamp: number
  dists: string
  weekly: string
  mints: string
  gaugesMint: string
  mintBlockNumber: number
  recycled: string
  pool2Mint: string
  teamMint: string
  recycledPercentage: number
  freshPercentage: number
  circulatingEmission: string
  circulatingSupply: string
}

/**
 * Convert GraphQL API response to store DAO format
 */
export function convertEpochApiDataToDAO(apiData: EpochApiData): EpochStoreDAO {
  return {
    epochNumber: apiData.epochNumber,
    startTimestamp: Number(apiData.startTimestamp),
    dists: apiData.dists,
    weekly: apiData.weekly,
    mints: apiData.mints,
    gaugesMint: apiData.gaugesMint,
    mintBlockNumber: apiData.mintBlockNumber,
    recycled: apiData.recycled,
    pool2Mint: apiData.pool2Mint,
    teamMint: apiData.teamMint,
    recycledPercentage: apiData.recycledPercentage,
    freshPercentage: apiData.freshPercentage,
    circulatingEmission: apiData.circulatingEmission,
    circulatingSupply: apiData.circulatingSupply,
  }
}
